import { useCallback, useEffect, useRef, useState } from "react";
import { editorInitializationQueue } from "./editor-initialization";

export default function useEditorInitialization() {
  const [attempt, setAttempt] = useState(0);
  const [status, setStatus] = useState("waiting");
  const finish = useRef(() => {});
  useEffect(() => {
    let live = true, timer;
    setStatus("waiting");
    const release = editorInitializationQueue.enqueue(() => {
      if (!live) return;
      setStatus("starting");
      timer = setTimeout(() => {
        if (!live) return;
        setStatus("failed"); release();
      }, 15000);
    });
    finish.current = (failed = false) => {
      if (!live) return;
      clearTimeout(timer);
      setStatus(failed ? "failed" : "ready");
      release();
    };
    return () => { live = false; clearTimeout(timer); release(); };
  }, [attempt]);
  return { status, attempt, initialized: useCallback(() => finish.current(), []),
    failed: useCallback(() => finish.current(true), []), retry: () => setAttempt((value) => value + 1) };
}
